<template>
  <div class="footer">
    <div class="footer-top">
      <div class="footer-top-left">
        <div v-for="nav in navs" :key="nav.title">
          <div class="footer-top-left-title">{{ nav.title }}</div>
          <div class="footer-top-left-item">
            <span v-for="item in nav.children" :key="item.label">{{
              item.label
            }}</span>
          </div>
        </div>
      </div>
      <div class="footer-top-right">
        <div class="footer-top-right-title">关注或联系我们</div>
        <div class="footer-top-right-item">
          <div class="footer-top-right-img center">
            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/组 857@2x-093900531.png"
              alt=""
            />
          </div>
          <div class="footer-top-right-item-text">
            <span>咨询电话：021-2078-7319(上海)</span>
            <span>投诉电话：021-2078-7301(上海)</span>
            <span>邮箱：ylabcloud@bioscires.com</span>
          </div>
        </div>
        <div class="footer-top-right-btn">联系我们</div>
      </div>
    </div>
    <div class="footer-bottom">
      <div>
        <span>Copyright © 上海懿贝瑞生物医药科技有限公司</span>
        <span style="margin: 0 10px"
          >地址：中国上海市浦东新区天雄路588弄11号楼</span
        >
        <span>邮箱：xks@bioscires.com</span>
      </div>
      <div style="margin-top: 10px">
        <span style="margin-right: 20px"> 沪ICP备16017892号-1 </span>
        <span
          ><svg-icon icon-class="badge" style="margin-bottom: 3px"></svg-icon>
          沪公网安备31011502019800号</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      navs: [
        {
          title: "产品",
          children: [
            {
              label: "产品介绍",
              path: "/site/product",
            },
            {
              label: "模板这是",
              path: "/site/product",
            },
            {
              label: "解决方案",
              path: "/site/product",
            },
          ],
        },
        {
          title: "解决方案",
          children: [
            {
              label: "客户管理CRM",
              path: "/site/product",
            },
            {
              label: "生产制造ERP",
              path: "/site/product",
            },
            {
              label: "进销存管理",
              path: "/site/product",
            },
            {
              label: "项目管理",
              path: "/site/product",
            },
          ],
        },
        {
          title: "学习资料",
          children: [
            {
              label: "模板中心",
              path: "/site/product",
            },
            {
              label: "产品手册",
              path: "/site/product",
            },
            {
              label: "资料下载",
              path: "/site/product",
            },
          ],
        },
        {
          title: "公司",
          children: [
            {
              label: "关于我们",
              path: "/site/product",
            },
            {
              label: "懿贝瑞官网",
              path: "/site/product",
            },
            {
              label: "小科鼠商城",
              path: "/site/product",
            },
            {
              label: "Ylab系统",
              path: "/site/product",
            },
          ],
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
.footer {
  background-color: #f8fafb;
}

.footer-top {
  padding: 60px 0 40px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  //   border: 1px solid #e5e5e5;
  .footer-top-left {
    display: flex;
    gap: 140px;
    .footer-top-left-title {
      font-size: 20px;
      line-height: 29px;
      color: #1d2129;
      margin-bottom: 20px;
    }
    .footer-top-left-item {
      display: flex;
      flex-direction: column;
      gap: 12px;
      color: #525967;
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;
    }
  }

  .footer-top-right {
    .footer-top-right-title {
      font-size: 20px;
      line-height: 29px;
      color: #1d2129;
      margin-bottom: 20px;
    }
    .footer-top-right-item {
      display: flex;
      align-items: center;
      gap: 14px;
      .footer-top-right-img {
        width: 86px;
        height: 86px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px #e1e7f3,
          -4px -4px 10px 0px rgba(255, 255, 255, 0.58);
        border-radius: 4px 4px 4px 4px;
      }
      img {
        width: 82px;
        height: 82px;
      }
      .footer-top-right-item-text {
        display: flex;
        flex-direction: column;
        gap: 12px;
        color: #525967;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .footer-top-right-btn {
      width: 194px;
      height: 34px;
      background: #2e98fe;
      margin-top: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: left;
      cursor: pointer;
    }
  }
}

.footer-bottom {
  border-top: 1px solid #d3d7de;
  padding: 40px 0 32px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
}
</style>